import _jsx from '@babel/runtime/helpers/esm/jsx';
import { memo } from 'react';
import { makeSelectUrlUserAreaSignIn } from '@dbh/webpages-redux';
import { useMakeSelect } from '@dbh/reselect-extra';
import Button from '@dbh/button';
import Text from '@dbh/text';
import { t as translationIds } from './constants-d0ade503.js';
import { S as SignUpTextWithLink } from './SignUpTextWithLink-528d051c.js';
import { C as CardContainer, a as CardWrapper } from './CardWrapper-bae155a2.js';
import styled from 'styled-components';
import '@dbh/styled-helpers';
import '@dbh/user-area-components';
import '@dbh/navbar';
import '@babel/runtime/helpers/esm/taggedTemplateLiteralLoose';
import '@dbh/media-queries';

const ButtonWrapper=/*#__PURE__*/styled.div.withConfig({componentId:"sc-lbjyk0-0"})(["width:100%;display:flex;align-items:center;justify-content:center;margin:2rem 0;"]);ButtonWrapper.displayName="ButtonWrapper";var ButtonWrapper$1 = ButtonWrapper;

var _Text,_SignUpTextWithLink;const SignInCard=/*#__PURE__*/memo(()=>{const a=useMakeSelect(makeSelectUrlUserAreaSignIn);return/*#__PURE__*/_jsx(CardContainer,{},void 0,/*#__PURE__*/_jsx(CardWrapper,{},void 0,_Text||(_Text=/*#__PURE__*/_jsx(Text,{size:"ff7",intlFormatter:!0},void 0,"components.SignInCard.loyalty_program_points")),/*#__PURE__*/_jsx(ButtonWrapper$1,{},void 0,/*#__PURE__*/_jsx(Button,{intlFormatter:!0,to:a,disabledLook:!0},void 0,translationIds.tappableSignin)),_SignUpTextWithLink||(_SignUpTextWithLink=/*#__PURE__*/_jsx(SignUpTextWithLink,{}))))});SignInCard.displayName="SignInCard";

export { SignInCard as default };
